var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',{attrs:{"background-color":"teal","centered":"","dark":""}},_vm._l((_vm.options),function(items,option){return _c('v-tab',{key:option,on:{"click":function($event){return _vm.setOption(option)}}},[_vm._v(_vm._s(option)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }